import React from 'react';
import { useTranslation } from 'react-i18next';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SimpleHoverPopperPopover from '@wix/da-ds/pkg/popper/presets/SimpleHoverPopperPopover';
export const PremiumIconWithPopover = ({ isPaidFolder, className })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SimpleHoverPopperPopover, {
        className: className,
        popoverContent: isPaidFolder ? t('deviationview.paywall.literature.premiumFolder.tooltip') : t('deviationview.paywall.literature.watchersOnly.tooltip')
    }, isPaidFolder ? /*#__PURE__*/ React.createElement(PremiumGallery, {
        size: IconSize.SMALL
    }) : /*#__PURE__*/ React.createElement(EyeDisc2, {
        size: IconSize.SMALL
    }));
};
PremiumIconWithPopover.displayName = 'PremiumIconWithPopover';
export default PremiumIconWithPopover;

//# sourceMappingURL=PremiumIconWithPopover.js.map